<template>

<div class="dashboard" style="max-width: 1280px;">

    <v-row dense>

        <v-col>

            <v-card outlined :loading="casePick==null" class="small-box fill-height">

                <v-card-title><lang t="DASHBOARD-STATS-CASE_PICK"></lang></v-card-title>

                <v-card-text v-if="casePick != null">
                    <div class="statsTotal">
                        <display-number :number="casePick.total" />
                    </div>
                    <div class="statsPercent">
                        {{ casePick.percent }}
                    </div>
                </v-card-text>

            </v-card>

        </v-col>

        <v-col>

            <v-card outlined :loading="unitPick==null" class="small-box fill-height">

                <v-card-title><lang t="DASHBOARD-STATS-UNIT_PICK"></lang></v-card-title>
                <v-card-text v-if="unitPick != null">

                    <div class="statsTotal">
                        <display-number :number="unitPick.total" />
                    </div>
                    <div class="statsPercent">
                        {{ unitPick.percent }}
                    </div>

                </v-card-text>

            </v-card>
          </v-col>

          <v-col>

            <v-card outlined :loading="casesPerTray==null" class="small-box fill-height">

                <v-card-title><lang t="DASHBOARD-STATS-CASES_PER_TRAY"></lang></v-card-title>

                <v-card-text v-if="casesPerTray != null">
                    <div class="statsTotal">
                        <display-number :number="casesPerTray.avg" />
                    </div>
                </v-card-text>

            </v-card>
          </v-col>

          <v-col>
            <v-card outlined :loading="incomplete==null" @click="goToItems" class="small-box fill-height">

                <v-card-title><lang t="DASHBOARD-STATS-INCOMPLETE"></lang></v-card-title>

                <v-card-text v-if="incomplete != null">
                    <div class="statsTotal">
                        <display-number :number="incomplete.total" />
                    </div>
                    <div class="statsPercent">
                        {{ incomplete.percent }}
                    </div>
                </v-card-text>

            </v-card>
          </v-col>

          <v-col>
            <v-card outlined :loading="bundleGroups==null" @click="$router.push({ name: 'settings-bundle_groups' })" class="small-box fill-height">

                <v-card-title><lang t="DASHBOARD-STATS-BUNDLEGROUPS"></lang></v-card-title>

                <v-card-text v-if="bundleGroups != null">
                    <div class="statsTotal">
                        <display-number :number="bundleGroups.total" />
                    </div>
                    <div class="statsPercent">
                        {{ bundleGroups.cases }}
                    </div>
                </v-card-text>

            </v-card>

        </v-col>

    </v-row>

    <v-row dense>

        <v-col cols="4" lg="4" md="12" sm="12">
            <v-card outlined :loading="caseCount.isLoading">
                <v-card-title><lang t="DASHBOARD-STATS-CASECOUNT"></lang></v-card-title>

                <v-card-text v-if="!caseCount.isLoading">
                    <apexchart :height="bundleTypes.options.xaxis.categories.length * 36" :options="caseCount.options" :series="caseCount.series"></apexchart>
                </v-card-text>

            </v-card>

        </v-col>

        <v-col cols="8" lg="8" md="12" sm="12">

            <v-card outlined :loading="bundleTypes.isLoading" >

                <v-card-title>
                  <lang t="DASHBOARD-STATS-BUNDLETYPES"></lang>
                  <v-select
                    v-model="bundleTypeSelected"
                    :items="['case', 'pack', 'unit']"
                    dense
                    flat
                    hide-details
                    height="20"
                    @change="onChangeBundleType"
                    style="max-width: 80px; margin-left: auto;">
                  </v-select>
                </v-card-title>

                <v-card-text v-if="!bundleTypes.isLoading">
                    <apexchart :key="bundleTypeSelected" :height="bundleTypes.options.xaxis.categories.length * 36" :options="bundleTypes.options" :series="bundleTypes.series"></apexchart>
                </v-card-text>

            </v-card>
        </v-col>

    </v-row>

    <v-row dense>

        <v-col cols="12" lg="12" md="12">

            <v-card outlined :loading="dimensionDistribution.isLoading">
                <v-card-title>
                  <lang t="DASHBOARD-STATS-DIMENSION_DISTRIBUTION"></lang>
                  <v-select
                    v-model="dimensionTypeSelected"
                    :items="['case', 'pack', 'unit']"
                    dense
                    flat
                    hide-details
                    height="20"
                    @change="onChangeDimensionType"
                    style="max-width: 80px; margin-left: auto;"
                    >
                  </v-select>
                </v-card-title>

                <v-card-text v-if="!dimensionDistribution.isLoading">
                    <apexchart height="300" :options="dimensionDistribution.options" :series="dimensionDistribution.series"></apexchart>
                </v-card-text>

            </v-card>

        </v-col>

    </v-row>

</div>


</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DisplayNumber from '../components/DisplayNumber.vue';

export default {

    components: {
        apexchart: VueApexCharts,
        DisplayNumber
    },

    data: function() {

        return {

            stats: null,

            casePick: null,
            unitPick: null,

            incomplete: null,
            bundleGroups: null,

            bundleTypeSelected: 'case',
            dimensionTypeSelected: 'case',

            caseCount: {
                isLoading: true,

                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                    },
                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                    }
                },

            },

            bundleTypes: {
                isLoading: true,


                series: [{
                  data: []
                }],


                options: {
                    chart: {
                        type: 'bar',
                    },
                    plotOptions: {
                      bar: {
                        borderRadius: 4,
                        horizontal: true,
                      }
                    },

                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                    }
                },

            },


            casesPerTray: null,

            caseHeightDistribution: {
                isLoading: true,
                series: [{
                    data: []
                }],
                options: {
                    chart: {
                        type: 'area',
                        zoom: {
                            enabled: true,
                            type: 'x',
                            autoScaleYaxis: false,
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                      curve: 'smooth'
                    },
                    xaxis: {
                        tickAmount: 12,
                        position: 'bottom',
                        type: 'numeric'
                    },
                    yaxis: {
                        tickAmount: 6,
                        labels: {
                            formatter: function(val) {
                                return parseFloat(val).toFixed(0) + '%';
                            }
                        }
                    }
                },

            },

            unitsPerCase: {
                isLoading: true,

                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                    },
                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                        tickAmount: 4,
                        labels: {
                            formatter: function(val) {
                                return parseFloat(val*100).toFixed(0) + '%';
                            }
                        }
                    }
                },

            },

            casesPerPallet: {
                isLoading: true,

                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                    },
                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                        tickAmount: 4,
                        labels: {
                            formatter: function(val) {
                                return parseFloat(val*100).toFixed(0) + '%';
                            }
                        }
                    }
                },

            },

            layersPerPallet: {
                isLoading: true,

                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                    },
                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                        tickAmount: 4,
                        labels: {
                            formatter: function(val) {
                                return parseFloat(val*100).toFixed(0) + '%';
                            }
                        }
                    }
                },

            },


            casesPerLayer: {
                isLoading: true,

                series: [{
                    data: []
                }],

                options: {
                    chart: {
                        type: 'bar',
                    },
                    dataLabels: {
                        enabled: false
                    },

                    xaxis: {
                        position: 'bottom',
                        type: 'category'
                    },
                    yaxis: {
                        tickAmount: 4,
                        labels: {
                            formatter: function(val) {
                                return parseFloat(val*100).toFixed(0) + '%';
                            }
                        }
                    }
                },

            },


            dimensionDistribution: {
                isLoading: true,

                series: [],

                options: {

                    chart: {
                        type: 'scatter',
                        animations: {
                            enabled: false,
                        },
                    },
                    colors: [],
                    xaxis: {
                        position: 'bottom',
                        type: 'numeric',
                        tickAmount: 12,
                    },

                    yaxis: {

                    },

                    fill: {
                        opacity: 0.75
                    },

                    markers: {
                        size: 2,
                        strokeColors: '#FFF',
                        strokeWidth: .6,
                        strokeOpacity: .3,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                    },


                    plotOptions: {
                        bubble: {
                          minBubbleRadius: 2,
                          maxBubbleRadius: 128,
                        },
                    },


                },
            }

        }
    },

    created() {

        this.initialize();

    },


    mounted() {

    },

    methods: {

        onChangeBundleType(val) {

          this.bundleTypes.series[0] = {
              name: 'BundleTypes',
              data: this.stats.bundletypes[val].map((c) => c.count)
          }
          this.bundleTypes.options.xaxis.categories = this.stats.bundletypes[val].map((c) => this.$t('bundletype_'+val+'_'+c.name));
          this.bundleTypes.isLoading = false;

        },

        onChangeDimensionType(val) {

          this.dimensionDistribution.series = [];
          for(var prop in this.stats.dimensionDistribution) {
              this.dimensionDistribution.series.push(
                  {
                      name: prop,
                      data: this.stats.dimensionDistribution[prop][val]
                  }
              )
          }

        },

        goToItems() {
          this.$router.push({ name: 'items', query: { 'incomplete': true }} );
        },

        initialize() {

            this.axios.get('dashboard/stats').then(res => {

                this.stats = res.data;
                let stats = res.data;

                // CASE PICK
                // ---------------------------------------------------------------------
                this.casePick = {
                    "total": stats.casePick.total,
                    "percent": stats.casePick.total > 0 ? stats.casePick.percent.toFixed(2) + '%' : 0,
                }

                // INCOMPLETE
                // ---------------------------------------------------------------------
                this.incomplete = {
                    "total": stats.incomplete.total,
                    "percent": stats.incomplete.total > 0 ? stats.incomplete.percent.toFixed(2) + '%' : 0,
                }

                // BUNDLE GROUPS
                // ---------------------------------------------------------------------
                this.bundleGroups = {
                    "total": stats.bundlegroups.total,
                    "cases": stats.bundlegroups.cases,
                }

                // BUNDLE TYPES
                // ---------------------------------------------------------------------

                this.bundleTypes.series[0] = {
                    name: 'Bundles',
                    data: stats.bundletypes.case.map((c) => c.count)
                }
                this.bundleTypes.options.xaxis.categories = stats.bundletypes.case.map((c) => this.$t('bundletype_case_'+c.name));
                this.bundleTypes.options.colors = ['#1B99A7'];
                this.bundleTypes.isLoading = false;

                // CASE COUNT
                // ---------------------------------------------------------------------

                this.caseCount.series[0] = {
                    name: 'CaseCount',
                    data: stats.caseCount.map((c) => c.count)
                }
                this.caseCount.options.xaxis.categories = stats.caseCount.map((c) => c.date);
                this.caseCount.options.colors = ['#1B99A7']
                this.caseCount.isLoading = false;


                // UNIT PICK
                // ---------------------------------------------------------------------
                this.unitPick = {
                    "total": stats.unitPick.total,
                    "percent": stats.unitPick.total > 0 ? stats.unitPick.percent.toFixed(2) + '%' : 0,
                }


                // CASES PER TRAY
                // ---------------------------------------------------------------------
                this.casesPerTray = {
                    "avg": stats.casesPerTray.avg
                },


                // CASE HEIGHT DISTRIBUTION
                // ---------------------------------------------------------------------
                this.caseHeightDistribution.series[0] = {
                    name: 'Cases/Height',
                    data: Object.keys(stats.caseHeightDistribution).map(function(key) { return [Number(key), stats.caseHeightDistribution[key]]; })
                }
                this.caseHeightDistribution.isLoading = false;


                // UNITS PER CASE
                // ---------------------------------------------------------------------
                this.unitsPerCase.series[0] = {
                    name: 'Units/Pallet',
                    data: Object.values(stats.unitsPerCase)
                }
                this.unitsPerCase.options.xaxis.categories = Object.keys(stats.unitsPerCase);
                this.unitsPerCase.isLoading = false;


                // CASES PER PALLET
                // ---------------------------------------------------------------------
                this.casesPerPallet.series[0] = {
                    name: 'Cases/Pallet',
                    data: Object.values(stats.casesPerPallet)
                }
                this.casesPerPallet.options.xaxis.categories = Object.keys(stats.casesPerPallet);
                this.casesPerPallet.isLoading = false;


                // LAYERS PER PALLET
                // ---------------------------------------------------------------------
                this.layersPerPallet.series[0] = {
                    name: 'Layers/Pallet',
                    data: Object.values(stats.layersPerPallet)
                }
                this.layersPerPallet.options.xaxis.categories = Object.keys(stats.layersPerPallet);
                this.layersPerPallet.isLoading = false;


                // CASES PER LAYER
                // ---------------------------------------------------------------------
                this.casesPerLayer.series[0] = {
                    name: 'Cases/Layer',
                    data: Object.values(stats.casesPerLayer)
                }
                this.casesPerLayer.options.xaxis.categories = Object.keys(stats.casesPerLayer);
                this.casesPerLayer.isLoading = false;


                // DIMENSION DISTRIBUTION
                // ---------------------------------------------------------------------

                this.dimensionDistribution.options.chart.type = 'scatter';
                // NONE = Grau, Highbay = Rot, Runpick = Blau
                this.dimensionDistribution.options.colors = ['#FF0000', '#888888', '#1B99A7'];

                for(var prop in stats.dimensionDistribution) {
                    this.dimensionDistribution.series.push(
                        {
                            name: prop,
                            data: stats.dimensionDistribution[prop].case
                        }
                    )
                }

                setTimeout(() => {
                    this.dimensionDistribution.isLoading = false;
                }, 500);


            })

        }


    }


}

</script>

<style lang="scss" scoped>

  .dashboard {

    .statsTotal {
      font-size: 2.6rem;
      line-height: 1;
      font-weight: 600;
      position: relative;
      text-align: center;
    }
    .statsPercent {
      text-align: center;
      padding: 10px 0 0 0;
    }

    @media (max-width: 768px) {
      .statsTotal {
        font-size: 24px;
      }
    }

    ::v-deep .apexcharts-toolbar {
      z-index: 5;
    }

    .small-box {
      min-width: 160px;
    }
  }
</style>
